import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { PrivateRoute, PublicRoute } from "../app/Routes.app";
import { PUBLIC_PATHS, PRIVATE_PATHS } from "../app/Paths.app";

// IMPORT COMPONENTS
import Header from "../common/header/Header.common";
import SideNav from "../common/sidenav/SideNav.common";

// IMPORT ROUES
import NotFoundPage from "../notFoundPage/NotFoundPage";

// ALL ROUTES ARE HERE
const App = () => {
    return (
        <Switch>
            {
                // PUBLIC ROUTES
                PUBLIC_PATHS.length &&
                PUBLIC_PATHS.map(({ path, component, restricted, exact }, index) => (
                    <PublicRoute 
                        key={index}
                        path={path} 
                        component={component} 
                        restricted={restricted}
                        exact={exact}
                    />
                ))
            }
            {
                // PRIVATE ROUTES
                PRIVATE_PATHS.length &&
                PRIVATE_PATHS.map(({ path, component, exact }, index) => (
                    <PrivateRoute 
                        key={index}
                        path={path} 
                        component={component}
                        exact={exact}
                    />
                ))
            }

            {/* NOT FOUND PAGE */}
            <Route render={() => <NotFoundPage />} />
        </Switch>
    )
}

// SHARED COMPONENTS AND ROUTER
const AppWithRouter = () => {
    return(
        <React.Fragment>
            <Router>
                <Header />

                <SideNav />
                
                <App />
            </Router>
        </React.Fragment>
    )
}

export default AppWithRouter;